import React from 'react';
import PropTypes from 'prop-types';
// import { Navbar, Nav, NavItem, MenuItem } from 'react-bootstrap';
// import { LinkContainer } from 'react-router-bootstrap';
// import { Link } from 'react-router-dom';
import { url } from '../../constants/routes';
import './styles.css';
import { connect } from '../../reducers/index';
import MyModal from '../../containers/Modal';
import MainLogo from './img/IAR_logo.svg';

class Navigation extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      navCollapsed: true,
      time: 10
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onToggleNav = this.onToggleNav.bind(this);
  }

  onToggleNav() {
    this.setState({
      navCollapsed: !this.state.navCollapsed
    });
  }

  openModal(modalState) {
    this.props.onOpenModal(modalState);
    const newTabLink = document.createElement('a');
    newTabLink.setAttribute('href', 'http://safety.utoronto.ca/');
    newTabLink.setAttribute('target', '_blank');

    window.timer = setTimeout(() => {
      newTabLink.click();
    }, 10000);

    window.interval = setInterval(() => {
      if (this.state.time > 0) {
        this.setState({
          time: this.state.time - 1
        });
      }
    }, 1000);
  }
  closeModal(modalState) {
    this.props.onCloseModal(modalState);
    clearTimeout(window.timer);
    clearInterval(window.interval);
    delete window.timer;
    delete window.interval;
    this.setState({
      time: 10
    });
  }

  skipToMain = () => {
    const isSmoothScrollSupported = ((document || {}).documentElement || {})
      .style
      ? 'scrollBehavior' in document.documentElement.style
      : false;

    if (isSmoothScrollSupported) {
      window.scrollTo({
        top: 500,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo(0, 500);
    }
  };

  render() {
    const { modal, role, history } = this.props;
    const { navCollapsed } = this.state;

    const linkStyle = !role.isActive ? 'link-disabled' : '';

    return (
      <div className="navigation-c" role="navigation">
        <div style={{ position: 'relative' }}>
          <a
            onClick={this.skipToMain}
            href="javascript:void(0)"
            style={{
              fontSize: '2px',
              color: 'white',
              position: 'absolute',
              top: 0,
              left: 0
            }}
          >
            skip to main content
          </a>
        </div>
        <nav className="navbar navbar-default" aria-labelledby="mainmenulabel">
          <h2 id="mainmenulabel" style={{ display: 'none' }}>
            Main Menu
          </h2>
          <div className="container">
            <div className="navbar-header">
              <a className="navbar-brand" href={url.MODULE}>
                <img
                  alt="Brand"
                  src={MainLogo}
                  className="main-logo"
                  alt="Link to IAR Home"
                />
              </a>
              <button
                type="button"
                className={`navbar-toggle ${navCollapsed && 'collapsed'}`}
                onClick={() => this.onToggleNav()}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
            </div>
            <div className={`collapse navbar-collapse ${navCollapsed || 'in'}`}>
              <ul className="nav navbar-nav navbar-right">
                <li>
                  <a
                    className={linkStyle}
                    href={url.MODULE}
                    aria-current="page"
                  >
                    Training
                  </a>
                </li>
                <li>
                  <a
                    className={linkStyle}
                    href={url.RESOURCES}
                    target="_blank"
                    aria-current="page"
                  >
                    Resources
                  </a>
                </li>
                <li>
                  <a
                    className={linkStyle}
                    href={url.REFERENCE}
                    target="_blank"
                    aria-current="page"
                  >
                    Quick Guide
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    aria-label="Emergency Tab from Navigation Bar"
                    id="modal-button"
                    onClick={this.openModal}
                    aria-current="modal"
                    style={{ cursor: 'pointer' }}
                  >
                    Emergency
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <MyModal
          show={modal.isOpen}
          onHide={this.closeModal}
          time={this.state.time}
        />
      </div>
    );
  }
}
Navigation.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  modal: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  role: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

Navigation.defaultProps = {
  modal: {},
  role: {},
};

Navigation.contextTypes = {
  router: PropTypes.object.isRequired
};

export default connect.modal(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.jsx